const BLANK_PLAYER = { id: 0, name: '', position: '', age: '', club: { id: 0, name: '' }, eligible: 'yes' };

// The find player Alpine object and other associated constants
window.appFindPlayer = () => {
    return {
        player: {}, // player details of whom to find a match
        search: {
            active: false, //status of the search popout
            query: '', //text query for the search popout
            results: [] //player name search results
        },
        filters: {}, // the search player name filters
        leagues: [], // a list of leagues to filter by
        clubs: [], // a list of clubs to filter by
        searchResultsLoading: false,  // track whether the search results are loading or not
        clubsLoaded: false, //track if the list of clubs has loaded or not

        router: function(state) {
            /*
             * Do nothing is the state is not defined
             */
            if( typeof(state) === 'undefined') {
                return;
            }

            /*
             * if we're at the root then no need to do anything
             */
            if( state.root && state.url == '' ) {
                return;
            }

            /*
             * if the URL is nothing then close popups if one was set
             */
            if( state.url === '' ){
                popupIsActive = false;
                popup.close(true);
                this.closePlayerMatches(true)
                return;
            }

            /*
             * player profile
             */
            let playerProfileUrl = /^player-profile\/([a-z-]+)\/(\d+)$/;
            let playerProfileMatches = state.url.match(playerProfileUrl);
            if( playerProfileMatches && playerProfileMatches.length === 3 ) {
                // if this wasn't a push (i.e. user click) then load the popup
                if( ! state.pushed ) {
                    playerProfile.load({ id: playerProfileMatches[2], name: playerProfileMatches[1] }, true)
                }
                return;
            }
        },

        init: function() {
            // get remaining searches for standard mode
            if( standard() ) {
                this.updateRemainingSearches();
            }

            // default sort state
            this.$store.sortBy = 'percentageMatch';

            //initialise the player
            this.player = Object.create( BLANK_PLAYER );

            // initialise the filters - this will be fully reset via openSearch
            this.filters = {
                league: { active: false, id: 0, label: getLang('all_leagues') },
                club: { active: false, id: 0, label: getLang('all_clubs') },
            };

            // if the club or league changes then update the player search results
            this.$watch( "filters.league.id", () => this.getPlayers());
            this.$watch( "filters.club.id", () => this.getPlayers());

            // basic routing for this page
            Spruce.watch('history', state => this.router(state));
        },

        /*
         * Not needed for find-players, but used for the find players popout which is used
         * with both find players and comparison
         */
        hasGoalkeeper: function() {
            return false;
        },

        /*
         * When a player is added, a popout appears with the option to search for
         * players by name, also a league and club can be optionally set which will
         * filter these results. This function opens the popout and preloads the
         * list of leagues
         */
        openSearch: function() {
            // Show the loading notice and cover the add player panel
            this.$store.loading = true;
            this.$store.cover = true;

            // Get the list of leagues
            axios.get('/api/leagues/')
                .then( response => {
                    // Save the player results
                    this.leagues = Object.create( response.data );

                    // Hide the loading notice and open the search popout
                    this.$store.loading = false;
                    this.search.active = true;

                    // reset the search query (this doesn't always trigger from closeSearch)
                    this.search.results = [];

                    // Focus the query input
                    this.$nextTick( () => this.$refs.searchQuery.focus() );

                })
                .catch( response => {
                    modal(getLang('generic_error'));

                    // Hide the loading notice
                    this.$store.loading = false;
                })

            //stop document scrolling
            document.querySelector('html').classList.add('overflow-hidden');
        },

        /*
         * Close the player search popout and tidy up, including resetting the
         * search filters and the search query.
         *
         * This is triggered either by a click to the popout's close button,
         * or when a row is clicked.
         */
        closeSearch: function() {
            // Close the search popout and hide the add player panel cover
            this.search.active = false;
            this.$store.cover = false;

            // Re-enable document scrolling
            document.querySelector('html').classList.remove('overflow-hidden');

            // reset the search query
            this.search.query = '';

            // reset the search results
            this.search.results = [];

            // Reset the search filters
            this.filters.league.active = false;
            this.filters.league.id = 0;
            this.filters.league.label = getLang('all_leagues');
            this.filters.club.active = false;
            this.filters.club.id = 0;
            this.filters.club.label = getLang('all_clubs');
        },

        /*
         * This sets the league to filter players with.
         *
         * This is triggered by clicking a row on the list of leagues.
         */
        setFilterLeague: function(league) {
            // Set the league name and ID
            this.filters.league.id = league.id;
            this.filters.league.label = league.name;

            // Hide the list of leagues
            this.filters.league.active = false;

            // reset the club
            this.filters.club.active = false;
            this.filters.club.id = 0;
            this.filters.club.label = getLang('all_clubs');

            // Set a flag that the clubs haven't been loaded, this is used to determine
            // whether or not the clubs filter dropdown is disabled or not
            this.clubsLoaded = false;

            // Load the list of clubs for this league
            if( league.id != 0 ) {
                axios.get('/api/clubs/' + league.id)
                .then( response => {
                    // Save the results
                    this.clubs = Object.create( response.data );

                    // Update the flag
                    this.clubsLoaded = true;

                    // show the clubs list
                    this.filters.club.active = true;
                })
                .catch( response => {
                    modal(getLang('generic_error'));
                })
            }
        },

        /*
         * This sets the club to filter players with.
         *
         * This is triggered by clicking a row on the list of clubs.
         */
        setFilterClub: function(club) {
            // Set the club name and ID
            this.filters.club.id = club.id;
            this.filters.club.label = club.name;

            // Hide the list of clubs
            this.filters.club.active = false;

        },

        /*
         * This fetches a list of players via AJAX for the player search popout,
         * it uses the player name (3 characters minimum) and optional filters
         * for the league and club.
         *
         * It is triggered by the search input field with an input handler.
         *
         * It is also called by watchers for filters.league.id and filters.club.id
         */
        getPlayers: function() {
             // Show the local loading notice just for the player name list
            this.searchResultsLoading = true;

             // Fetch the players that match the query and filters
            let params = {
                league_id: this.filters.league.id,
                club_id: this.filters.club.id,
            };

            axios.get('/api/players/' + ( this.search.query.length < 3 ? '-1' : this.search.query ), {
                params
            })
                .then( response => {
                    // Save the player results
                    this.search.results = Object.create( response.data );

                    // Hide the local loading notice
                    this.searchResultsLoading = false;
                })
                .catch( response => {
                    modal(getLang('generic_error'));
                })
        },

        /*
         * Sets the player to find matches for.
         *
         * This is triggered either when a row is clicked.
         */
        setPlayer: function(player, fromRouter) {
            if( ! fromRouter ) {
                // close the search
                this.closeSearch()
            }

            // Set the player's details
            this.player = {
                id: player.id,
                name: player.name,
                position: player.position,
                positionTranslated: player.positionTranslated,
                age: player.age,
                club: { id: player.club.id, name: player.club.name },
            };
        },

        /*
         * Removes the active player and starts the process again.
         *
         * This is triggered by the close button on a player's card.
         */
        removePlayer: function() {
            // Clear the player's details
            this.player = Object.create( BLANK_PLAYER );
        },
    }
};
